import React from 'react';
import {StyleSheet, View} from 'react-native';
import CampCard from '../cards/CampCard';
import SessionCard from '../cards/SessionCard';
import EmptyState from '../EmptyState';

interface CampsListViewProps {
    sessions: any;
    camps: any;
    sessionsHistory?: boolean;
    setSessions?: any;
    isSessionView?: boolean;
    campSessionPage?: boolean;
    isEditing?: boolean;
    camp?: any;
    hasSearchCriteria?: boolean;
    onClearSearch?: any;
    showEmptyState?: boolean;
}

const CampsListView: React.FC<CampsListViewProps> = ({
                           sessions,
                           camps,
                           sessionsHistory = false,
                           setSessions = null,
                           isSessionView = false,
                           campSessionPage = false,
                           isEditing = false,
                           camp = null,
                           hasSearchCriteria = false,
                           onClearSearch = null,
                           showEmptyState = false
                       }) => {
    const styles = StyleSheet.create({
        container: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            paddingHorizontal: campSessionPage ? 0 : 40,
            justifyContent: 'center',
            zIndex: 5,
        },
    });

    const renderContent = () => {
        if (isSessionView) {
            if (!sessions) {
                return (<></>);
            }

            // Handle both array and object formats
            const sessionsArray = Array.isArray(sessions) 
                ? sessions 
                : Object.values(sessions);

            const filteredSessions = sessionsArray.filter((session: any) => session && !session.isHidden);

            if (filteredSessions.length === 0 && showEmptyState) {
                return (
                    <EmptyState 
                        type="sessions" 
                        hasSearchCriteria={hasSearchCriteria}
                        onClearSearch={onClearSearch}
                    />
                );
            }

            return (
                filteredSessions.map((session: any, index: number) => (
                    <SessionCard
                        key={session.sessionId || session.id || index}
                        session={session}
                        setSessions={setSessions}
                        campSessionPage={campSessionPage}
                        isEditing={isEditing}
                        camp={camp}
                    />
                ))
            );
        } else {
            if ((!camps || camps.length === 0) && showEmptyState) {
                return (
                    <EmptyState 
                        type="camps" 
                        hasSearchCriteria={hasSearchCriteria}
                        onClearSearch={onClearSearch}
                    />
                );
            }

            return (
                camps.map((camp, index) => (
                    <CampCard
                        key={camp.campId}
                        camp={camp}
                    />
                ))
            );
        }
    };

    return (
        <View style={styles.container}>
            {renderContent()}
        </View>
    );
};

export default CampsListView;